import PropTypes from 'prop-types';
import React from 'react';
import Styled from 'styled-components';
import buildTwoThirdLegalTextString from '../../util/buildTwoThirdLegalTextString';

export const LegalTextContainer = Styled.div`
  font-size: .625em;
  margin-bottom: 10px;
  line-height: 1.25em;
  min-width: 296px;
  color: ${props => props.theme.labelColor};
`;

const LegalText = ({
  amount, total, monthlyPayment, effectiveInterestRate, nominalInterestRate, bank, term,
}) => (
  <LegalTextContainer>
    {buildTwoThirdLegalTextString({
      netAmountTwoThird: amount,
      nominalInterestRateTwoThird: nominalInterestRate,
      effectiveInterestRateTwoThird: effectiveInterestRate,
      monthlyRateTwoThird: monthlyPayment,
      totalAmountTwoThird: total,
      bankName: bank,
      term,
    })}
  </LegalTextContainer>
);

LegalText.propTypes = {
  amount: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  monthlyPayment: PropTypes.number.isRequired,
  nominalInterestRate: PropTypes.number.isRequired,
  effectiveInterestRate: PropTypes.number.isRequired,
  bank: PropTypes.string.isRequired,
  term: PropTypes.number.isRequired,
};

export default LegalText;
